import React from 'react';
import { Grid, SelectChangeEvent } from '@mui/material';
import { Invitation } from '@/operator/graphql/types/Invitation';
import UploadedInvitationList from './UploadedInvitationList';
import SmallHeaderWithIconAndDescription from '@/operator/components/general/header/SmallHeaderWithIconAndDescription';
import { DropdownOption } from "Interfaces/Dropdown/SelectDropdownInterfaces";
import Dropdown from "Components/Dropdown";

export interface UploadedInvitationListProps {
    invitationList: Invitation[];
    setInvitationList: React.Dispatch<React.SetStateAction<Invitation[]>>;
    teamOptions: DropdownOption[];
    teamId: string;
    setTeamId: React.Dispatch<React.SetStateAction<string>>
}

const SendInvitationList: React.FC<UploadedInvitationListProps> = ({
    invitationList,
    setInvitationList,
    teamOptions,
    teamId,
    setTeamId
}) => {

    const handleTeamChange = (e: SelectChangeEvent) => {
        const teamId = e.target.value;
        setTeamId(teamId)
    };

    return (
        <Grid container gap="10px">
            <SmallHeaderWithIconAndDescription
                title={`You uploaded ${invitationList.length} emails via CSV`}
                description="Each of these will be used to invite members to your organization. You
        also have the option of making each member an admin."
            />
            <Dropdown
                value={teamId}
                options={teamOptions}
                helperText="Which team will they be invited to?"
                sx={{ marginTop: 2 }}
                fullWidth
                onChange={handleTeamChange}
            />
            <UploadedInvitationList
                invitationList={invitationList}
                setInvitationList={setInvitationList}
            />
        </Grid>
    );
};

export default SendInvitationList;
